module.exports = __webpack_public_path__ + "img/step_3-7.2cf13fa8.png";